import { render, staticRenderFns } from "./Aging.vue?vue&type=template&id=ea280aaa&scoped=true"
import script from "./Aging.vue?vue&type=script&lang=js"
export * from "./Aging.vue?vue&type=script&lang=js"
import style0 from "./Aging.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../Followups/aging-page.scss?vue&type=style&index=1&id=ea280aaa&prod&lang=scss&scoped=true&external"
import style2 from "./Aging.vue?vue&type=style&index=2&id=ea280aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea280aaa",
  null
  
)

export default component.exports